






















import { Component, Mixins, Emit } from 'vue-property-decorator'
import BaseIcon from 'vuecomponents/base_icon.vue'
import localStorage from 'bits/safe_storage'
import { IntlMixin } from 'vuemixins/intl_mixin'
import { __ } from 'bits/intl'

@Component({
  components: {
    BaseIcon,
  },
})
export default class AccessibilityDropdown extends Mixins(IntlMixin) {
  isOpen = false
  highContrast = false

  mounted() {
    const highContrastValue = localStorage.getItem('highContrast')
    this.highContrast = highContrastValue ? JSON.parse(highContrastValue) : false

    if (this.highContrast) {
      this.setContrast()
    }
  }

  openMenu(): void {
    this.isOpen = !this.isOpen
  }

  setContrast(): void {
    const body = document.getElementsByTagName('body')[0]

    if (body.classList.length == 0) {
      body.classList.add('high-contrast')
    }
  }

  @Emit('input')
  change(e) {
    const checked = e.target.checked
    const body = document.getElementsByTagName('body')[0]

    // Enabling more color contrast for sign up button on homepage
    // Style located in home_app.vue
    if (checked) {
      body.classList.add('high-contrast')
      this.highContrast = true
      localStorage.setItem('highContrast', JSON.stringify(this.highContrast))
    } else {
      body.classList.remove('high-contrast')
      this.highContrast = false
      localStorage.setItem('highContrast', JSON.stringify(this.highContrast))
    }
  }
}
